import React, { useState, useEffect } from "react";
import { EyeOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";
import ComplaintReport from "FileGenerator/AdminFileGenerator/ComplaintReport";
import {
  fetchComplaintDetails,
  fetchAllDepartments,
} from "Services/AdminServices/ComplaintServices/ComplaintService";
import { ComplaintStatusLabel } from "Constants/Enums/Complaint/ComplaintStatusEnum";

function useComplaints() {
  const [loading, setLoading] = useState(true);
  const [departments, setDepartments] = useState([]);
  const [selectedDepartment, setSelectedDepartment] = useState("All");
  const [dataSource, setDataSource] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const { handleDownloadReport } = ComplaintReport(selectedDepartment, dataSource, filteredData);

  useEffect(() => {
    if (departments.length > 0) {
    }
  }, [departments]);

  useEffect(() => {
    const initializeData = async () => {
      try {
        setLoading(true);

        const complaintData = await fetchComplaintDetails();
        const departmentData = await fetchAllDepartments();
        // Process complaints AFTER departments are known
        const updatedRows = complaintData.map((info) => {
          const departmentName =
            departmentData.find((dept) => dept.id === info.departmentId)?.name || "Unknown";

          return {
            key: info.id?.toString(),
            ComplaintTitle: info.complaintTypeName || "unknown",
            ComplainantEmail: info.complainantEmail || "-",
            ComplainantPhone: info.complainantPhone || "-",
            ComplainantName: info.complainantFirstName
              ? `${info.complainantFirstName} ${info.complainantLastName || ""}`
              : `User ID: ${info.complainantEmployeeId}`,
            ComplaintAgainst: info.complaintAgainstFirstName
              ? `${info.complaintAgainstFirstName} ${info.complaintAgainstLastName || ""}`
              : `User ID: ${info.complaintAgainstUserId}`,
            DepartmentId: info.departmentId,
            Department: departmentName,
            Status: ComplaintStatusLabel[info.status],
            Action: (
              <span style={{ display: "flex", alignItems: "center" }}>
                <Link to={`/complaintDetail/${info.id}/${info.complainantEmployeeId}`}>
                  <EyeOutlined
                    className="eyeOutlined"
                    style={{ color: "#10b981" }} // This is your professional emerald green
                  />
                </Link>
              </span>
            ),
          };
        });

        setDataSource(updatedRows);
        filterData(selectedDepartment, updatedRows);
        setDepartments(departmentData);
      } catch (error) {
        console.error("Error initializing data:", error);
      } finally {
        setLoading(false);
      }
    };

    initializeData();
  }, []);

  const filterData = (departmentId, data) => {
    if (departmentId === "All") {
      setFilteredData(data);
    } else {
      const filtered = data.filter((item) => String(item.DepartmentId) === departmentId);
      setFilteredData(filtered);
    }
  };

  const handleDepartmentChange = (e) => {
    const selectedDept = e.target.value;
    setSelectedDepartment(selectedDept);
    filterData(selectedDept, dataSource);
  };

  const columns = [
    {
      title: "Complaint Title",
      dataIndex: "ComplaintTitle",
      key: "ComplaintTitle",
    },
    {
      title: "Complaint Against Name",
      dataIndex: "ComplaintAgainst",
      key: "ComplaintAgainst",
    },
    {
      title: "Complainant  Name",
      dataIndex: "ComplainantName",
      key: "ComplainantName",
    },
    {
      title: "Department",
      dataIndex: "Department",
      key: "Department",
    },
    {
      title: "Status",
      dataIndex: "Status",
      key: "Status",
    },
    {
      title: "Complaint Detail",
      dataIndex: "Action",
      key: "Action",
    },
  ];

  return {
    columns,
    handleDownloadReport,
    handleDepartmentChange,
    loading,
    departments,
    selectedDepartment,
    filteredData,
  };
}

export default useComplaints;
